import React, { useContext, useEffect, useState } from "react";
import "./Place_order.css";
import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
import Coupon_canvas from "../../common/offcanvas/coupon-offcanvas/Coupon_canvas";
import OrderPlacedSuccessfullModal from "../../common/modals/OrderPlacedSuccessfullModal/OrderPlacedSuccessfullModal";
import { logDOM } from "@testing-library/react";
import useRazorpay from "react-razorpay";
import { useDispatch, useSelector } from "react-redux";
import { createOrder } from "../../../features/order/orderSlice";
import { getAllCart } from "../../../features/cart/cartSlice";
import { Spinner } from "react-bootstrap";
import { IDS } from "../../../utils/IDS";
import { useNavigate } from "react-router-dom";
import { getCoupons } from "../../../features/admin/common/Slice";
import Login_Layout_Modal from "../../common/modals/login-signup-modals/Login_Layout_Modal";
import { Context } from "../../../utils/context";
import { encodeId } from "../../../utils/common";

const Place_order = ({
  deliveryNote,
  paymentValue,
  CouponData,
  setCouponData,
  orderAddress,
  paymentData,
  setDeliveryNote,
  ...props
}) => {
  const [couponShow, setCouponShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modelType, setModelType] = useState("");
  const [selectLogin, setSelectLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [trackId, setTrackId] = useState();
  const { signin } = useContext(Context);
  // const [CouponData, setCouponData] = useState("");
  const navigate = useNavigate();


  const dispatch = useDispatch();
  const handlePlaceOrder = () => {
    setLoading(true);

    if (!signin) {
      setModelType("select_login");
      setSelectLogin(true);
      return;
    }
    if (!paymentValue) {
      alert("Please select a payment method before placing the order: ");
      return;
    }

    // console.log(paymentValue, "paymentValue");

    if (paymentValue == IDS.Payment_Methods.Online) {
      handleRazorpay(paymentData?.order_summary?.grand_total);
    } else {
      finalFunction();
    }

    // Open order success modal only after payment is selected
    // setShowModal(true);
  };

  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();

  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Om TApovan",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Prajwal Vaychal",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const finalFunction = async (razorpay) => {

    setLoading(true);
    const datafinal = {
      address_id: orderAddress?.id,
      payment_method_id: paymentValue,
      order_summary: paymentData?.order_summary,
      order_Details_summary: paymentData?.order_Details_summary,
      delivery_note: deliveryNote,
      // delivery_date: selectedDate,
      // time_slot_id: selectedTime,
      // gst_number: GSTNumber,
    };

    if (razorpay) {
      datafinal.payment_id = razorpay;
    }

    const res = await dispatch(createOrder(datafinal));
    // console.log({ createOrder: res });

    if (res.meta?.requestStatus === "fulfilled") {
      // if (res?.payload?.data) {
      dispatch(getAllCart(props?.isSignIn));
      setTrackId(res?.payload?.data);
      setShowModal(true);
      setDeliveryNote("");
      setTimeout(() => {
        navigate("/explore-latest-products");
        setLoading(false);
      }, 2000)
      // dispatch(getNotifications());
      // window.location.href = res?.payload?.data?.redirectUrl;
      // if()

      // } else {
      // setTrackId(res?.payload?.data);
      // setLoading(false);
      // dispatch(getAllCart(props?.isSignIn));
      // // handleClick();
      // setShowModal(true);

      // }
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.response?.data?.errors) {
        alert(res.payload?.response?.data?.errors);
        navigate("/cart");
      }
      if (res.payload?.payment_method_id) {
        alert("Please Select Payment Option!");
      }
      setLoading(false);
    }
  };

  const coupons = useSelector((state) => state.common.addCoupons);

  // console.log({ coupons });

  useEffect(() => {
    if (paymentData?.order_summary?.total_selling_price) {
      dispatch(
        getCoupons({ amount: paymentData?.order_summary?.total_selling_price })
      );
    }
  }, [dispatch, paymentData?.order_summary?.total_selling_price]);

  return (
    <>
      <section className="Place_order_sec">
        <div className="">
          <p className="headp">
            <img
              className="percimg"
              src={
                process.env.PUBLIC_URL + "/assets/images/icons/greenpercent.png"
              }
            />
            Something Special for you!
          </p>
          <div className="odplacebody">
            <div className="row">
              <div className="col-6">
                <p className="coupp">
                  <img
                    className="coupicn"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/icons/coupon.png"
                    }
                  />
                  {CouponData?.name || "Coupons"}
                </p>
              </div>
              {CouponData ? (
                <div className="col-6 text-end">
                  <button
                    className="viewbtn"
                    type="button"
                    onClick={() => {
                      setCouponShow(false);
                      setCouponData("");
                    }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="col-6 text-end">
                  <button
                    className="viewbtn"
                    type="button"
                    onClick={() => setCouponShow(true)}
                  >
                    View
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="mt-3">

            {loading ?
              <Pink_Btn
                btnText={
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Processing...
                  </>

                }
              /> :
              <Pink_Btn
                btnText={"Place Order"}
                onClick={handlePlaceOrder}
              />}


            {/* <Pink_Btn btnText={'Place Order'} onClick={() => { setShowModal(true) }} /> */}
          </div>
        </div>

        <Coupon_canvas
          setCouponData={setCouponData}
          data={paymentData?.order_summary}
          coupons={coupons?.data?.data ?? []}
          show={couponShow}
          onHide={() => setCouponShow(false)}
        />

        <OrderPlacedSuccessfullModal
          paymentData={paymentData}
          show={showModal}
          onHide={() => setShowModal(false)}
          baseLink={`/track-order/${encodeId(trackId?.id)}`}
        />

        <Login_Layout_Modal
          modalType={modelType}
          show={selectLogin}
          onHide={() => setSelectLogin(false)}
        />
      </section>
    </>
  );
};

export default Place_order;
